import axios from "./axios";

/**
 * Obtiene el resumen de todas las OLTs y ONUs
 * desde el endpoint FastAPI
 */
export const fetchOLTStatus = async () => {
  try {
    const response = await axios.get("/dashboard/olts-summary");
    return response.data;
  } catch (error) {
    console.error("Error al obtener estado de OLTs:", error);
    return [];
  }
};
